// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._8q5zrz0 {
  min-height: auto;
}
._8q5zrz1 {
  display: grid;
  grid-template-columns: 1fr;
}
._8q5zrz2 {
  height: var(--_18w76bw1u);
  padding: var(--_18w76bw9) var(--_18w76bwe) var(--_18w76bwg);
}
._8q5zrz3 {
  border: 1px solid var(--_18w76bw28);
  height: var(--_18w76bw1u);
}
._8q5zrz4 {
  align-items: center;
  background-color: var(--_18w76bw25);
  padding: var(--_18w76bwg) var(--_18w76bwj);
  border-bottom: 1px solid var(--_18w76bw28);
  justify-content: space-between;
}
._8q5zrz5 {
  line-height: var(--_18w76bw45);
  word-break: break-all;
}
._8q5zrz6 {
  padding: var(--_18w76bwh) var(--_18w76bwh) var(--_18w76bwl);
  background-color: var(--_18w76bw23);
  max-width: var(--_18w76bw1o);
  box-shadow: 0 10px 25px 0 rgb(0 0 0 / 40%);
}
._8q5zrz7 {
  background-color: var(--_18w76bw23);
  padding: var(--_18w76bwg) var(--_18w76bwj) var(--_18w76bwj);
  width: var(--_18w76bw1u);
  flex-grow: 1;
}
._8q5zrz8 {
  align-items: center;
  background-color: var(--_18w76bw23);
  justify-content: space-between;
  padding: var(--_18w76bwg) var(--_18w76bwj);
  border-top: 1px solid var(--_18w76bw28);
}
._8q5zrz9 {
  padding-left: var(--_18w76bw9);
  padding-right: var(--_18w76bw9);
  display: flex;
  align-items: center;
  width: var(--_18w76bw1t);
  gap: var(--_18w76bwa);
}
._8q5zrza {
  line-height: var(--_18w76bw45);
  text-decoration: underline;
  color: var(--_18w76bw2e);
}
._8q5zrza:hover {
  color: var(--_18w76bw2d);
}
._8q5zrzb {
  max-width: var(--_18w76bw14);
  line-height: var(--_18w76bw44);
}
@media screen and (min-width: 768px) {
  ._8q5zrz0 {
    min-height: 344px;
  }
  ._8q5zrz1 {
    grid-template-columns: 1fr 1fr;
  }
}
@media screen and (min-width: 1024px) {
  ._8q5zrz1 {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media screen and (max-width: 768px) {
  ._8q5zrz2 {
    padding: var(--_18w76bw9) var(--_18w76bwg) var(--_18w76bwg);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,2DAA2D;AAC7D;AACA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,0CAA0C;EAC1C,0CAA0C;EAC1C,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,2DAA2D;EAC3D,mCAAmC;EACnC,4BAA4B;EAC5B,0CAA0C;AAC5C;AACA;EACE,mCAAmC;EACnC,2DAA2D;EAC3D,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,8BAA8B;EAC9B,0CAA0C;EAC1C,uCAAuC;AACzC;AACA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,kCAAkC;EACpC;AACF;AACA;EACE;IACE,2DAA2D;EAC7D;AACF","sourcesContent":["._8q5zrz0 {\n  min-height: auto;\n}\n._8q5zrz1 {\n  display: grid;\n  grid-template-columns: 1fr;\n}\n._8q5zrz2 {\n  height: var(--_18w76bw1u);\n  padding: var(--_18w76bw9) var(--_18w76bwe) var(--_18w76bwg);\n}\n._8q5zrz3 {\n  border: 1px solid var(--_18w76bw28);\n  height: var(--_18w76bw1u);\n}\n._8q5zrz4 {\n  align-items: center;\n  background-color: var(--_18w76bw25);\n  padding: var(--_18w76bwg) var(--_18w76bwj);\n  border-bottom: 1px solid var(--_18w76bw28);\n  justify-content: space-between;\n}\n._8q5zrz5 {\n  line-height: var(--_18w76bw45);\n  word-break: break-all;\n}\n._8q5zrz6 {\n  padding: var(--_18w76bwh) var(--_18w76bwh) var(--_18w76bwl);\n  background-color: var(--_18w76bw23);\n  max-width: var(--_18w76bw1o);\n  box-shadow: 0 10px 25px 0 rgb(0 0 0 / 40%);\n}\n._8q5zrz7 {\n  background-color: var(--_18w76bw23);\n  padding: var(--_18w76bwg) var(--_18w76bwj) var(--_18w76bwj);\n  width: var(--_18w76bw1u);\n  flex-grow: 1;\n}\n._8q5zrz8 {\n  align-items: center;\n  background-color: var(--_18w76bw23);\n  justify-content: space-between;\n  padding: var(--_18w76bwg) var(--_18w76bwj);\n  border-top: 1px solid var(--_18w76bw28);\n}\n._8q5zrz9 {\n  padding-left: var(--_18w76bw9);\n  padding-right: var(--_18w76bw9);\n  display: flex;\n  align-items: center;\n  width: var(--_18w76bw1t);\n  gap: var(--_18w76bwa);\n}\n._8q5zrza {\n  line-height: var(--_18w76bw45);\n  text-decoration: underline;\n  color: var(--_18w76bw2e);\n}\n._8q5zrza:hover {\n  color: var(--_18w76bw2d);\n}\n._8q5zrzb {\n  max-width: var(--_18w76bw14);\n  line-height: var(--_18w76bw44);\n}\n@media screen and (min-width: 768px) {\n  ._8q5zrz0 {\n    min-height: 344px;\n  }\n  ._8q5zrz1 {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n@media screen and (min-width: 1024px) {\n  ._8q5zrz1 {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n@media screen and (max-width: 768px) {\n  ._8q5zrz2 {\n    padding: var(--_18w76bw9) var(--_18w76bwg) var(--_18w76bwg);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
